export { default } from "./getTextChunks";
